(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------- Header scroll state ---------------- */
  var header = document.querySelector("[data-site-header]");
  function onScroll() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 24);
  }
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---------------- Mobile menu ---------------- */
  var menu = document.querySelector("[data-mobile-menu]");
  var menuOpenBtn = document.querySelector("[data-menu-open]");
  var menuCloseBtn = document.querySelector("[data-menu-close]");
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  }
  if (menuOpenBtn) menuOpenBtn.addEventListener("click", function () { setMenu(true); });
  if (menuCloseBtn) menuCloseBtn.addEventListener("click", function () { setMenu(false); });
  document.querySelectorAll("[data-mobile-menu] a").forEach(function (link) {
    link.addEventListener("click", function () { setMenu(false); });
  });

  var htmlEl = document.documentElement;

  /* ---------------- Intro curtain (homepage, once per session) ---------------- */
  (function () {
    var intro = document.getElementById("waksi-intro");
    var playing = htmlEl.classList.contains("waksi-intro");
    if (!intro || !playing) {
      htmlEl.classList.remove("waksi-intro");
      return;
    }

    function finish() {
      if (intro.dataset.done) return;
      intro.dataset.done = "1";
      try { sessionStorage.setItem("waksi_intro_seen", "1"); } catch (e) {}
      document.dispatchEvent(new CustomEvent("waksi:intro-done"));
      intro.classList.add("is-leaving"); // slides up (still display:flex)
      var kill = setTimeout(cleanup, 1100);
      intro.addEventListener("transitionend", function (e) {
        if (e.target !== intro || e.propertyName !== "transform") return;
        clearTimeout(kill);
        cleanup();
      });
    }
    function cleanup() {
      htmlEl.classList.remove("waksi-intro");
      if (intro && intro.parentNode) intro.parentNode.removeChild(intro);
    }

    // hold on the logo, then lift the curtain
    setTimeout(finish, 1550);
  })();

  /* ---------------- Scroll reveal ---------------- */
  function inHero(el) { return !!(el.closest && el.closest("[data-hero]")); }

  if (!prefersReducedMotion && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "-80px" }
    );
    document.querySelectorAll(".reveal, .reveal-stagger").forEach(function (el) {
      if (!inHero(el)) observer.observe(el);
    });
  } else {
    document.querySelectorAll(".reveal, .reveal-stagger").forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  /* ---------------- Scroll progress bar ---------------- */
  if (!prefersReducedMotion) {
    var bar = document.createElement("div");
    bar.className = "scroll-progress";
    document.body.appendChild(bar);
    var ticking = false;
    function paintBar() {
      ticking = false;
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + "%";
    }
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) { ticking = true; requestAnimationFrame(paintBar); }
      },
      { passive: true }
    );
    paintBar();
  }

  /* ---------------- Cursor light (desktop, fine pointer) ---------------- */
  if (!prefersReducedMotion && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    var glow = document.createElement("div");
    glow.className = "cursor-glow";
    document.body.appendChild(glow);
    var gx = window.innerWidth / 2, gy = window.innerHeight / 2, cx = gx, cy = gy, gRAF = 0;
    function glowFrame() {
      cx += (gx - cx) * 0.14;
      cy += (gy - cy) * 0.14;
      glow.style.transform = "translate3d(" + cx.toFixed(1) + "px," + cy.toFixed(1) + "px,0)";
      if (Math.abs(gx - cx) > 0.5 || Math.abs(gy - cy) > 0.5) gRAF = requestAnimationFrame(glowFrame);
      else gRAF = 0;
    }
    window.addEventListener("pointermove", function (e) {
      gx = e.clientX; gy = e.clientY;
      document.body.classList.add("has-cursor-glow");
      if (!gRAF) gRAF = requestAnimationFrame(glowFrame);
    }, { passive: true });
    window.addEventListener("pointerleave", function () {
      document.body.classList.remove("has-cursor-glow");
    });
  }

  /* ---------------- Magnetic buttons ---------------- */
  if (!prefersReducedMotion && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    document.querySelectorAll(".btn").forEach(function (btn) {
      btn.addEventListener("pointermove", function (e) {
        var r = btn.getBoundingClientRect();
        var mx = (e.clientX - r.left - r.width / 2) / (r.width / 2);
        var my = (e.clientY - r.top - r.height / 2) / (r.height / 2);
        btn.style.transform = "translate(" + (mx * 5).toFixed(1) + "px," + (my * 4 - 3).toFixed(1) + "px)";
      });
      btn.addEventListener("pointerleave", function () { btn.style.transform = ""; });
    });
  }

  /* ---------------- Generic image parallax ([data-parallax]) ---------------- */
  if (!prefersReducedMotion) {
    var pxEls = document.querySelectorAll("[data-parallax]");
    if (pxEls.length) {
      var pxTick = false;
      function paintParallax() {
        pxTick = false;
        var vh = window.innerHeight || 1;
        pxEls.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > vh) return;
          var p = (rect.top + rect.height / 2 - vh / 2) / vh; // -0.5..0.5
          var amt = parseFloat(el.getAttribute("data-parallax")) || 24;
          el.style.transform = "translate3d(0," + (p * -amt).toFixed(1) + "px,0)";
        });
      }
      window.addEventListener("scroll", function () {
        if (!pxTick) { pxTick = true; requestAnimationFrame(paintParallax); }
      }, { passive: true });
      paintParallax();
    }
  }

  /* ---------------- Accordion (FAQ, product info) ---------------- */
  document.querySelectorAll("[data-accordion-trigger]").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var item = trigger.closest(".accordion-item");
      var panel = item.querySelector(".accordion-item__panel");
      var isOpen = item.classList.contains("is-open");

      item.parentElement.querySelectorAll(".accordion-item.is-open").forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove("is-open");
          openItem.querySelector(".accordion-item__panel").style.maxHeight = null;
          openItem.querySelector("[data-accordion-trigger]").setAttribute("aria-expanded", "false");
        }
      });

      item.classList.toggle("is-open", !isOpen);
      trigger.setAttribute("aria-expanded", String(!isOpen));
      panel.style.maxHeight = isOpen ? null : panel.scrollHeight + "px";
    });
  });

  /* ---------------- Before / after compare slider ---------------- */
  document.querySelectorAll("[data-compare]").forEach(function (compare) {
    var beforeWrap = compare.querySelector("[data-compare-before-wrap]");
    var handle = compare.querySelector("[data-compare-handle]");
    var range = compare.querySelector("[data-compare-range]");

    function setPosition(pct) {
      pct = Math.min(100, Math.max(0, pct));
      beforeWrap.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
      handle.style.left = pct + "%";
      if (range) range.value = pct;
    }

    function fromClientX(clientX) {
      var rect = compare.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      setPosition(pct);
    }

    compare.addEventListener("pointerdown", function (e) { fromClientX(e.clientX); });
    compare.addEventListener("pointermove", function (e) {
      if (e.buttons === 1) fromClientX(e.clientX);
    });
    if (range) {
      range.addEventListener("input", function () { setPosition(Number(range.value)); });
    }
    setPosition(50);
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var mainImg = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
        var newSrc = thumb.getAttribute("data-full-src");
        if (mainImg && newSrc) {
          mainImg.style.opacity = "0";
          setTimeout(function () {
            mainImg.src = newSrc;
            mainImg.style.opacity = "1";
          }, 150);
        }
      });
    });
  });

  /* ---------------- Subtle parallax on brand texture ---------------- */
  if (!prefersReducedMotion) {
    var parallaxSections = document.querySelectorAll("[data-parallax-section]");
    if (parallaxSections.length) {
      window.addEventListener(
        "scroll",
        function () {
          parallaxSections.forEach(function (section) {
            var bg = section.querySelector("[data-parallax-bg]");
            if (!bg) return;
            var rect = section.getBoundingClientRect();
            var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
            var offset = (progress - 0.5) * 40;
            bg.style.transform = "translateY(" + offset + "px)";
          });
        },
        { passive: true }
      );
    }
  }

  /* ---------------- AJAX cart ---------------- */
  var cartDrawer = document.getElementById("cart-drawer");

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add("is-open");
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove("is-open");
  }
  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", openCartDrawer);
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (btn) {
    btn.addEventListener("click", closeCartDrawer);
  });

  function refreshCartSections() {
    fetch("/?section_id=cart-drawer-items")
      .then(function () {
        // Sections rendering is handled by re-fetching the drawer partials below.
      })
      .catch(function () {});
  }

  function updateCartDrawerFromResponse() {
    Promise.all([
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "?section_id=header" : "/"),
    ]);
    // Simplest robust approach: fetch cart.js for totals + re-render item list via cart.js line items.
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat("fr-FR", { style: "currency", currency: currency || "EUR" }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + " " + (currency || "EUR");
    }
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById("cart-drawer-body");
    var footer = document.getElementById("cart-drawer-footer");
    var cartCountEls = document.querySelectorAll("[data-cart-count]");

    cartCountEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "flex" : "none";
    });

    if (!body || !footer) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty">' + (window.waksiStrings ? window.waksiStrings.cartEmpty : "Votre panier est vide.") + "</p>";
      footer.innerHTML = "";
      return;
    }

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : "";
        return (
          '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<div class="cart-line__media">' + img + "</div>" +
          '<div class="cart-line__info">' +
          "<div>" +
          '<p style="font-size:.9rem">' + item.product_title + "</p>" +
          (item.variant_title ? '<p style="font-size:.75rem;opacity:.6">' + item.variant_title + "</p>" : "") +
          "</div>" +
          '<div style="display:flex;align-items:center;justify-content:space-between">' +
          '<span class="cart-line__qty">' +
          '<button type="button" data-cart-decrease data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">\u2212</button>' +
          '<span style="padding:0 .6rem">' + item.quantity + "</span>" +
          '<button type="button" data-cart-increase data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          "</span>" +
          "<span>" + money(item.final_line_price, cart.currency) + "</span>" +
          "</div>" +
          "</div>" +
          '<button type="button" class="cart-line__remove" data-cart-remove data-key="' + item.key + '" aria-label="Retirer">&times;</button>' +
          "</div>"
        );
      })
      .join("");

    footer.innerHTML =
      '<div class="cart-summary-row"><span>Sous-total</span><span>' +
      money(cart.total_price, cart.currency) +
      "</span></div>" +
      '<a href="/cart" class="btn btn--primary" style="width:100%;margin-bottom:.75rem;display:flex">Passer commande</a>' +
      '<a href="/cart" style="display:block;text-align:center;font-size:.75rem;letter-spacing:.08em;text-transform:uppercase;opacity:.6">Voir le panier complet</a>';

    body.querySelectorAll("[data-cart-increase], [data-cart-decrease]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-key");
        var qty = Number(btn.getAttribute("data-qty"));
        changeCartLine(key, Math.max(0, qty));
      });
    });
    body.querySelectorAll("[data-cart-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        changeCartLine(btn.getAttribute("data-key"), 0);
      });
    });
  }

  function changeCartLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  document.querySelectorAll("[data-add-to-cart-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector("[type=submit]");
      var originalText = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) submitBtn.textContent = "Ajout\u2026";

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add to cart failed");
          return r.json();
        })
        .then(function () {
          if (submitBtn) submitBtn.textContent = "Ajout\u00e9 \u2713";
          updateCartDrawerFromResponse();
          openCartDrawer();
          setTimeout(function () {
            if (submitBtn) submitBtn.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          if (submitBtn) submitBtn.textContent = originalText;
        });
    });
  });

  // Keep the cart drawer in sync on load so the counter is correct.
  updateCartDrawerFromResponse();

  /* ---------------- Cart page quantity controls (no drawer) ---------------- */
  document.querySelectorAll("[data-cart-page-qty]").forEach(function (input) {
    input.addEventListener("change", function () {
      changeCartLineAndReload(input.getAttribute("data-key"), Number(input.value));
    });
  });
  document.querySelectorAll("[data-cart-page-remove]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      changeCartLineAndReload(btn.getAttribute("data-key"), 0);
    });
  });
  function changeCartLineAndReload(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function () {
      window.location.reload();
    });
  }

  /* ---------------- Hero product visual (entrance + pointer tilt + scroll rotate) ---------------- */
  (function () {
    var hero = document.querySelector("[data-hero]");
    if (!hero) return;
    var media = hero.querySelector("[data-hero-media]");
    var inner = hero.querySelector("[data-hero-tilt]");
    if (!media || !inner) return;

    // Entrance: reveal the hero copy + photo together. If the intro curtain
    // is playing, hold until it lifts so the animation isn't wasted behind it.
    var revealed = false;
    function revealHero() {
      if (revealed) return;
      revealed = true;
      hero.querySelectorAll(".reveal, .reveal-stagger").forEach(function (el) {
        el.classList.add("is-visible");
      });
      media.classList.add("is-in");
    }
    if (htmlEl.classList.contains("waksi-intro")) {
      document.addEventListener("waksi:intro-done", function () {
        requestAnimationFrame(revealHero);
      }, { once: true });
      setTimeout(revealHero, 4200); // safety
    } else {
      requestAnimationFrame(revealHero);
      setTimeout(revealHero, 400);
    }

    var isDesktop = window.matchMedia("(min-width: 768px)").matches;
    var canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (prefersReducedMotion || !isDesktop || !canHover) return;

    var glow = hero.querySelector("[data-hero-glow]");
    var targetX = 0, targetY = 0, curX = 0, curY = 0;
    var scrollProgress = 0;
    var inView = true;
    var running = false;

    function onPointerMove(e) {
      var rect = media.getBoundingClientRect();
      targetX = (e.clientX - rect.left) / rect.width - 0.5;  // -0.5 .. 0.5
      targetY = (e.clientY - rect.top) / rect.height - 0.5;
      media.classList.add("is-glowing");
      if (glow) {
        media.style.setProperty("--hero-glow-x", (25 + (targetX + 0.5) * 50).toFixed(1) + "%");
        media.style.setProperty("--hero-glow-y", (18 + (targetY + 0.5) * 46).toFixed(1) + "%");
      }
      start();
    }

    function onPointerLeave() {
      targetX = 0;
      targetY = 0;
      media.classList.remove("is-glowing");
      start();
    }

    function onScroll() {
      var rect = hero.getBoundingClientRect();
      scrollProgress = Math.min(1, Math.max(0, -rect.top / (rect.height || 1)));
      start();
    }

    function start() {
      if (running || !inView) return;
      running = true;
      requestAnimationFrame(frame);
    }

    function frame() {
      if (!inView) { running = false; return; }

      curX += (targetX - curX) * 0.08;
      curY += (targetY - curY) * 0.08;

      var rot = curX * 2.6 + scrollProgress * 6;             // a few degrees, total
      media.style.setProperty("--hero-tx", (curX * 14).toFixed(2) + "px");
      media.style.setProperty("--hero-ty", (curY * 10 - scrollProgress * 8).toFixed(2) + "px");
      media.style.setProperty("--hero-rot", rot.toFixed(2) + "deg");
      media.style.setProperty("--hero-shadow-tx", (curX * -9).toFixed(2) + "px");
      media.style.setProperty("--hero-shadow-scale", (1 + scrollProgress * 0.12).toFixed(3));
      media.style.setProperty("--hero-shadow-opacity", (0.7 - scrollProgress * 0.4).toFixed(2));

      var settled =
        Math.abs(targetX - curX) < 0.0008 && Math.abs(targetY - curY) < 0.0008;
      if (settled) { running = false; return; }
      requestAnimationFrame(frame);
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) start();
        },
        { threshold: 0 }
      );
      io.observe(hero);
    }

    media.addEventListener("pointermove", onPointerMove);
    media.addEventListener("pointerleave", onPointerLeave);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  })();
})();
